import React from "react";
import Table from "../../../Table";
import dayjs from "dayjs";
import Modal from "../../../modal";
import NoData from "../../../noData";

const TransfersTable = ({
  loading,
  getTransferData,
  lastElementRef,
  setIsDeleteOpen,
  isDeleteOpen,
  closeDeleteModal,
  openDeleteModal,
  handleDeleteTransfers,
  handleEditTransfer,
}) => {
  const tableHeading = {
    no: <div className="ml-2 text-center">No.</div>,
    date: <div className=" text-center px-2">Date</div>,
    source: <div className="px-2">Source</div>,
    destination: <div className="px-2">Destination</div>,
    amount: <div className="text-center">Amount</div>,
    editDetail: <div className="mr-2 text-center"></div>,
  };

  const headData = Object.values(tableHeading);

  const bodyData = getTransferData?.map((e, index) => {
    return {
      no: <div className="ml-2 text-center">{index + 1}</div>,
      date: (
        <div className=" text-center px-2">
          {dayjs(e?.date).format("DD/MM/YYYY")}
        </div>
      ),
      source: (
        <div className="px-2">{e?.sourcepaymentmethod?.paymentmethod}</div>
      ),
      destination: (
        <div className="px-2">{e?.receiverpaymentmethod?.paymentmethod}</div>
      ),
      amount: <div className="text-center">{e?.amount}</div>,
      editDetail: (
        <div className="mr-2  flex justify-center gap-5">
          <img
            src="/images/pencilIcon.svg"
            alt=""
            onClick={() => handleEditTransfer(e)} // Call the edit function
            className="cursor-pointer"
          />
          <img
            onClick={() => openDeleteModal(e)}
            className="cursor-pointer"
            src="/images/deleteIcon.svg"
            alt=""
          />
        </div>
      ),
    };
  });
  return (
    <>
      {getTransferData?.length > 0 ? (
        <Table
          tableHeading={headData}
          tableData={bodyData}
          headingClass={"text-left"}
          lastElementRef={lastElementRef}
        />
      ) : (
        <NoData />
      )}
      <Modal
        loading={loading}
        modalWidth="w-1/3"
        isOpen={isDeleteOpen}
        setIsOpen={setIsDeleteOpen}
        openModal={openDeleteModal}
        closeModal={closeDeleteModal}
        handleBtn2={handleDeleteTransfers}
        imgSrc="/images/exclamationIcon.svg"
        title="Are You Sure?"
        btn1="Cancel"
        btn2="Delete"
        btnClass={"justify-end"}
        modalContent={
          <p className="text-lg font-medium">
            Deleting will permanently remove this Detail the system.
          </p>
        }
      />
    </>
  );
};

export default TransfersTable;
